import { useMemo } from "react"

import { useRoutes } from "@/contexts/use-routes"

export function useTrainingLinks(trackId?: string) {
  const { trainingModules, trainingTracks } = useRoutes()

  const trainingLinks = useMemo(() => {
    let modules = trainingModules

    // If trackId provided, filter to only that track's modules (in order)
    if (trackId) {
      const track = trainingTracks.find((t) => t.id === trackId)
      if (track) {
        const moduleIds = track.module_ids
        modules = moduleIds
          .map((id) => trainingModules.find((m) => m.id === id))
          .filter((m): m is NonNullable<typeof m> => m !== undefined)
      }
    }

    return modules.map((module) => ({
      title: module.display_name,
      id: module.id,
      sections: module.sections.map((section) => ({
        id: section.id,
        title: section.display_name,
        url: section.url,
      })),
    }))
  }, [trainingModules, trainingTracks, trackId])

  return { trainingLinks }
}
